<div class="assistant-input-wrapper">
  <ion-textarea
    class="assistant-input"
    autocapitalize="sentences"
    [rows]="1"
    [autoGrow]="true"
    [placeholder]="placeholder | translate"
    [(ngModel)]="value"
    (ngModelChange)="valueChange.emit(value)"
  >

    @if (value.trim() !== '') {

      <div
        slot="end"
        class="send-button"
        [ngClass]="{'disabled': action !== assistantActionEnum.waiting}"
        (click)="sendPrompt()"
      >
        <yu-icon name="arrow-up"></yu-icon>
      </div>

    }

  </ion-textarea>
</div>
